import { alpha, Paper, styled } from '@/shared/ui/mui';
/**
 * SearchBarWrapper - Container for search input components
 *
 * A paper wrapper designed for search bars with purple-themed
 * focus states. Features smooth transitions and enhanced shadow
 * on hover/focus.
 *
 * @example
 * ```tsx
 * <SearchBarWrapper>
 *   <SearchIcon />
 *   <InputBase placeholder="Search..." />
 * </SearchBarWrapper>
 * ```
 */
export const SearchBarWrapper = styled(Paper)(({ theme }) => ({
  padding: '4px 16px',
  display: 'flex',
  alignItems: 'center',
  borderRadius: '12px',
  boxShadow: `0 4px 12px ${alpha(theme.palette.common.black, 0.05)}`,
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${theme.palette.grey[200]}`,
  transition: 'all 0.3s ease',
  '&:hover, &:focus-within': {
    boxShadow: `0 6px 16px ${alpha(theme.palette.primary.main, 0.15)}`,
    borderColor: alpha(theme.palette.primary.main, 0.3),
  },
}));
